import { useMutation, useQueryClient } from "@tanstack/react-query";
import { dealApi, dealQueryKeys } from "service/crm/api/deal";
import {
  restoreDealOptions,
  setDealOptionAssociated,
} from "./dealOptionsCache";
import { contactQueryKeys } from "../api/contact";

export const useLinkDealMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: dealApi.linkDealToContact,
    onMutate: async (variables) => {
      const scopeKey = dealQueryKeys.byContact(variables.contactUuid);
      await queryClient.cancelQueries({ queryKey: scopeKey });
      return {
        snapshot: setDealOptionAssociated(
          queryClient,
          scopeKey,
          variables.dealUuid,
          true,
        ),
      };
    },
    onError: (_error, _variables, context) =>
      restoreDealOptions(queryClient, context?.snapshot),
    onSettled: (_data, _error, variables) => {
      queryClient.invalidateQueries({ queryKey: dealQueryKeys.lists() });
      queryClient.invalidateQueries({
        queryKey: dealQueryKeys.byContact(variables.contactUuid),
      });
      queryClient.invalidateQueries({
        queryKey: contactQueryKeys.activities(variables.contactUuid),
      });
    },
  });
};
